import { useState } from 'react';
import { Box, TextField, Button, Alert, Typography } from '@mui/material';

export default function LoginForm({ onSubmit }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(form);
    } catch (error) {
      if (error.message === 'Network Error') {
        setError('Error de conexión. ');
        return;
      }
      
      setError('Credenciales inválidas');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h4" align="center" gutterBottom>
        Iniciar Sesión
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label="Usuario"
        name="username"
        value={form.username}
        onChange={handleChange}
        margin="normal"
        required
      />
      <TextField
        fullWidth
        label="Contraseña"
        name="password"
        type="password"
        value={form.password}
        onChange={handleChange}
        margin="normal"
        required
      />

      <Button
        fullWidth
        type="submit"
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
      >
        Ingresar
      </Button>
    </Box>
  );
}
